import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e1750e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-layout-sider" }
const _hoisted_2 = { class: "app-layout-sider-inner" }
const _hoisted_3 = { class: "logo" }
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "system-name"
}
const _hoisted_6 = { class: "menu" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_sidebar_item = _resolveComponent("sidebar-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createVNode(_component_router_link, { to: _ctx.logoRoute }, {
          default: _withCtx(() => [
            (_ctx.logo)
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  class: "logo-image",
                  src: _ctx.logo
                }, null, 8, _hoisted_4))
              : _createCommentVNode("", true),
            (_ctx.sidebar.opened)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_5, _toDisplayString(_ctx.systemName), 1))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["to"])
      ]),
      _createElementVNode("section", _hoisted_6, [
        _createVNode(_component_el_scrollbar, { "wrap-class": "scrollbar-wrapper" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_menu, {
              "default-openeds": _ctx.defaultOpeneds,
              "default-active": _ctx.activeMenu,
              collapse: _ctx.isCollapse,
              "unique-opened": false,
              "collapse-transition": false,
              "background-color": _ctx.variables.menuBg,
              "text-color": _ctx.variables.menuText,
              "active-text-color": _ctx.variables.menuTextActive,
              mode: "vertical"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (menuItem) => {
                  return (_openBlock(), _createBlock(_component_sidebar_item, {
                    key: menuItem.resourceId,
                    item: menuItem,
                    collapse: _ctx.isCollapse
                  }, null, 8, ["item", "collapse"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["default-openeds", "default-active", "collapse", "background-color", "text-color", "active-text-color"])
          ]),
          _: 1
        })
      ])
    ])
  ]))
}